import classNames from "classnames";

function SectionHeader({ text, className }) {
  return (
    <div className="absolute w-full h-max bottom-10">
      <div
        className={classNames(
          "h-max w-max ml-2 mr-20 sticky left-0 pl-3 select-none",
          className
        )}
      >
        <span className="text-4xl text-white opacity-20 font-extrabold pr-10">
          {text}
        </span>
      </div>
    </div>
  );
}

export default SectionHeader;
